import React from 'react'
import './TTSControls.css'
import Button from '../../../shared/components/ui/Button'

/**
 * TTS 생성 및 재생 컨트롤 컴포넌트
 */
function TTSControls({ section, isGeneratingTTS, onGenerateTTS, onAudioUpload }) {
  const handleAudioUpload = (event) => {
    const file = event.target.files[0]
    if (file && onAudioUpload) {
      // 오디오 파일 형식 검증
      const validTypes = ['audio/mp3', 'audio/mpeg', 'audio/wav', 'audio/m4a', 'audio/ogg']
      if (validTypes.includes(file.type) || file.name.match(/\.(mp3|wav|m4a|ogg)$/i)) {
        onAudioUpload(section.id, file)
      } else {
        alert('지원하지 않는 음성 파일 형식입니다. MP3, WAV, M4A, OGG 파일을 사용해주세요.')
      }
    }
    // 파일 입력 초기화
    event.target.value = ''
  }

  return (
    <div className="tts-controls">
      <div style={{ display: 'flex', gap: '8px' }}>
        <Button 
          onClick={() => onGenerateTTS(section.id, section.text)}
          disabled={isGeneratingTTS}
          variant={isGeneratingTTS ? 'loading' : 'primary'}
          style={{ flex: 1 }}
        >
          {isGeneratingTTS ? '생성중...' : '음성 생성'}
        </Button>
        
        <Button
          as="label"
          variant="secondary"
          style={{ flex: 1, cursor: 'pointer' }}
        >
          음성 업로드
          <input
            type="file"
            accept="audio/*,.mp3,.wav,.m4a,.ogg"
            onChange={handleAudioUpload}
            style={{
              position: 'absolute',
              opacity: 0,
              width: '1px',
              height: '1px',
              overflow: 'hidden'
            }}
          />
        </Button>
      </div>
    </div>
  )
}

export default TTSControls